import React, { useState, useEffect } from 'react';
import GroupQuestionsTextInput from './GroupQuestionsTextInput';
import { useTranslation } from "react-i18next";
import { setObjectValue } from '../../helpers/general';
import { useGetQuestion, useUpdateQuestion, useInsertQuestion } from '../../hooks/groups/Questions';
import GroupQuestionsSelectInput from './GroupQuestionsSelectInput';
import { useQuestionTypeOptions } from '../../hooks/groups/QuestionTypes';
import LoadingSpinner from '../global/LoadingSpinner';

function GroupQuestionsEditForm({ id, type = "SCORE", moduleId, onClose, onNew, onAdd, onConfirm, checked=false }) {
    const { t, i18n } = useTranslation();

    let { data: questionData, isLoading: questionDataLoading, isError :questionDataError, refetch } = useGetQuestion(id);
    const { mutate: insertQuestion, data: insertedQuestion } = useInsertQuestion();
    const { mutate: updateQuestion, data: updatedQuestion } = useUpdateQuestion(id, moduleId)
    const [newId, setNewID] = useState(id);
    const [isError, setIsError] = useState(false);
    const [showError, setShowError] = useState(false);

    const questionTypeOptions = useQuestionTypeOptions();
    let qType = type ? questionTypeOptions.find(element => type === element.name) : questionTypeOptions[0];
    const [isAnswer, setIsAnswer] = useState(qType.answer);


    useEffect(() => {   
        refetch();
    }, [id, refetch]);

    useEffect(() => {
        //refetch()
        if (insertedQuestion && !newId) {
            setNewID(insertedQuestion.id)
            onNew?.(insertedQuestion.id);
            onClose?.();
        }
    }, [newId, insertedQuestion, onNew, onClose, questionData]);

    //Save data to DB
    const onSave = async () => {

        if(isError) { setShowError(isError); return;} 

        if (newId && questionData.id) {
            updateQuestion({ data: questionData, message: t('toast.chQ') });
            onConfirm(questionData);
            onClose?.()
        }
        else {
            insertQuestion({ data: questionData, message: t('toast.adQ') });
        }
    };

    const handleUpdate = (e) => {
        setIsError(e.error);
        setObjectValue(questionData, e.index, e.data);
        //onConfirm("asd");
        e.answer && setIsAnswer((e.answer === true || e.answer === "true") ? true : false);
    }

    if (questionDataLoading) return <LoadingSpinner/>

    return (<>

        <div className="productsWrap">
            <div className="productSingle">
                <div className="productSingleForm">
                    <div className="modulElementNew modulElementNewCriterion">
                        <div>
                            <div className="row">
                                <div className="editMe-wrap">
                                    <strong>{t("admin.group.qType")}</strong>
                                    <div className="editMe-field">
                                        {<GroupQuestionsSelectInput index="answer_type" disabled={id} value={questionData.answer_type} onChange={handleUpdate} error={showError} />}
                                    </div>
                                </div>
                                <div className="editMe-wrap">
                                    <strong>{t("admin.group.text")}</strong>
                                    <div className="editMe-field">
                                        <GroupQuestionsTextInput index="text" value={questionData.text} onChange={handleUpdate} isNew={!newId} error={showError} />
                                    </div>
                                </div>
                                {(isAnswer) && (
                                    <div className="editMe-wrap">
                        
                                        <strong>{t("admin.group.anss")}</strong>
                                        <div className="editMe-field">
                                            <GroupQuestionsTextInput index="answer" value={questionData && (questionData.answer)} isNew={!newId} isAnswer={isAnswer} onChange={handleUpdate} error={showError} />
                                        </div>
                                    
                                    </div>
                                )}

                                <span className={checked? "openIndicator user-select-none" :"openIndicator openIndicatorDisabled user-select-none"}
                                    onClick={() => onAdd?.()}
                                    title={t("admin.group.diQu")}>
                                </span>
                                <div className="editMe-wrap">
                                    <button className="btn btn-default btn-confirm" onClick={() => { onSave() }}>potrdi</button>
                                    <button type="button" className="btn btn-default btn-cancel" onClick={() => {refetch(); onClose?.()}}>prekliči</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    </>);
};

export default GroupQuestionsEditForm;